<template>
  <div class="cpt-toast-inner flex-items-center gap-[10px]">
    <div
      class="title text-tx-1 text-[14px] font-semibold leading-[normal]"
      v-html="title"
    />
    <div
      class="slot-wrapper"
      v-if="showSlot"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToastInner',
  props: {
    title: {
      type: String,
      default: '',
    },
    showSlot: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
